import Profile from './Profile'
import ReclipPlayer from './ReclipPlayer'
import SharePlayer from './SharePlayer'
import JsonViewer from './JsonViewer'
import AnimatedVideoPlayer from './AnimatedVideoPlayer'
import AnimationOutline from './AnimationOutline'

const Modals = () => {
  return (
    <>
      <Profile />
      <ReclipPlayer />
      <SharePlayer />
      <JsonViewer />
      <AnimatedVideoPlayer />
      <AnimationOutline />
    </>
  )
}

export default Modals
